import {
  getYoutubeEmbedUrl,
  isDirectVideoFileUrl,
  parseYoutubeVideoId,
} from "../utils/videoUrl";

interface CompanyVideoPlayerProps {
  url: string;
  className?: string;
}

export function CompanyVideoPlayer({ url, className = "" }: CompanyVideoPlayerProps) {
  const trimmed = url.trim();
  const youtubeId = parseYoutubeVideoId(trimmed);

  if (youtubeId) {
    return (
      <div className={`aspect-video w-full bg-black ${className}`.trim()}>
        <iframe
          src={getYoutubeEmbedUrl(youtubeId)}
          title="Company video"
          className="h-full w-full border-0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          referrerPolicy="strict-origin-when-cross-origin"
          allowFullScreen
        />
      </div>
    );
  }

  if (isDirectVideoFileUrl(trimmed)) {
    return (
      <video
        src={trimmed}
        controls
        className={`aspect-video w-full bg-black object-contain ${className}`.trim()}
        preload="metadata"
      >
        Your browser does not support the video tag.
      </video>
    );
  }

  return (
    <div
      className={`flex aspect-video w-full items-center justify-center bg-black/90 px-6 text-center text-sm text-white ${className}`.trim()}
    >
      <a
        href={trimmed}
        target="_blank"
        rel="noopener noreferrer"
        className="text-[#FF6A00] underline hover:text-orange-300"
      >
        Open company video
      </a>
    </div>
  );
}
